// extracted by mini-css-extract-plugin
export default {"ul":"SidebarCategory_ul__V1ITV","label":"SidebarCategory_label__ot-Or"};